import "./template_special_offers.css";